import { Component, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";

import { OptionsElementAccessor } from "../options-accessor";

/**
 * Switches toggle the state of a single item on or off.
 *
 * Use switches to:
 *
 * * Toggle a single item on or off, on mobile and tablet
 * * Immediately activate or deactivate something
 *
 * Switches should be used instead of radio buttons if each item in a set can be independently controlled.
 *
 * Switches can be used as an Angular `FormControl`, in both reactive and template driven forms.
 */
@Component({
  selector: "ui-input[type=switch]",
  templateUrl: "./switch.component.html",
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputSwitchComponent extends OptionsElementAccessor {}
